// Imports => Constants
import { ENDPOINTS } from '@constants';

export class WithdrawalsAPI {
  constructor(Client, config) {
    this.Client = Client;
    this.config = config;
  }
  get_by_id = (uid, params) => {
    return this.Client.get(ENDPOINTS.WITHDRAWALS.GET_BY_ID(uid), {
      params,
    }).then((response) => response.data.data);
  };
}

export default WithdrawalsAPI;
